import { Link } from 'react-router-dom';

const homelinkfooter = (
    <Link to="/">
        <img
            className="SvgLogo"
            alt="Dr Prox"
            loading="lazy"
        />
    </Link>
);

export default homelinkfooter;
